const Contract = require('./Contract');

class Program {
  constructor() {
    this.init();
  }

  init() {
    this.program_id = undefined;
    this.provider_id = undefined;
    this.name = undefined;
    this.available_days = undefined;
    this.preferred_days = undefined;
    this.days = undefined;
    this.start_time = undefined;
    this.end_time = undefined;
    this.contracts = undefined;
  }

  copy() {
    const cp = new Program();

    cp.program_id = this.program_id;
    cp.provider_id = this.provider_id;
    cp.name = this.name;
    cp.available_days = this.available_days;
    cp.preferred_days = this.preferred_days;
    cp.days = this.days;
    cp.start_time = this.start_time;
    cp.end_time = this.end_time;
    if (this.contracts) {
      cp.contracts = [];
      this.contracts.forEach((c) => {
        cp.contracts.push(c.copy());
      });
    }

    return cp;
  }

  buildFromJSON(obj) {
    this.init();
    if (obj) {
      this.program_id = obj.program_id ? obj.program_id.toString() : undefined;
      this.provider_id = obj.provider_id ? obj.provider_id.toString() : undefined;
      this.name = obj.name ? obj.name : undefined;
      this.available_days = obj.available_days ? obj.available_days : undefined;
      this.preferred_days = obj.preferred_days ? obj.preferred_days : undefined;
      this.days = obj.days ? obj.days : undefined;
      this.start_time = (obj.start_time === undefined) || (obj.start_time === null)
        ? undefined : obj.start_time;
      this.end_time = (obj.end_time === undefined) || (obj.end_time === null)
        ? undefined : obj.end_time;

      if (obj.contracts) {
        this.contracts = [];
        obj.contracts.forEach((c) => {
          const contract = new Contract();
          contract.buildFromJSON(c);
          this.contracts.push(contract);
        });
      }
    }
  }

  toString() {
    let result = this.name ? this.name : '';
    return result;
  }

  getId() {
    return this.program_id;
  }

  setId(program_id) {
    this.program_id = program_id ? program_id.toString() : undefined;
  }
  
  getProviderId() {
    return this.provider_id;
  }

  setProviderId(provider_id) {
    this.provider_id = provider_id ? provider_id.toString() : undefined;
  }

  getName() {
    return this.name;
  }

  setName(name) {
    this.name = name;
  }

  getAvailableDays() {
    if (this.available_days === undefined) {
      return undefined;
    }

    const days = [];
    let n = this.available_days;
    let day = 0;
    while (n) {
      if (n & 0x1) {
        days.push(day);
      }
      n = n >> 1;
      day = day + 1;
    }

    return days;
  }

  setAvailableDays(available_days) {
    if (available_days === undefined) {
      this.available_days = undefined;
    } else {
      let days = 0;
      available_days.forEach((d) => {
        if ((d >= 0) && (d <= 6)) {
          days = days + (1 << d);
        }
      });
      this.available_days = days;
    }
  }

  getPreferredDays() {
    if (this.preferred_days === undefined) {
      return undefined;
    }

    const days = [];
    let n = this.preferred_days;
    let day = 0;
    while (n) {
      if (n & 0x1) {
        days.push(day);
      }
      n = n >> 1;
      day = day + 1;
    }

    return days;
  }

  setPreferredDays(preferred_days) {
    if (preferred_days === undefined) {
      this.preferred_days = undefined;
    } else {
      let days = 0;
      preferred_days.forEach((d) => {
        if ((d >= 0) && (d <= 6)) {
          days = days + (1 << d);
        }
      });
      this.preferred_days = days;
    }
  }

  getDays() {
    return this.days;
  }

  setDays(days) {
    this.days = days;
  }

  getStartHour() {
    return (this.start_time !== undefined) ? Math.floor(this.start_time / 60) : undefined;
  }

  setStartHour(hour) {
    this.start_time = (hour === undefined) ? undefined :
      (this.start_time === undefined) ? (hour * 60) : ((hour * 60) + this.start_time % 60);
  }

  getStartMinute() {
    return (this.start_time !== undefined) ? Math.floor(this.start_time % 60) : undefined;
  }

  setStartMinute(minute) {
    this.start_time = (minute === undefined) ? undefined :
      (this.start_time === undefined) ? minute : (60 * Math.floor(this.start_time / 60) + minute);
  }

  getEndHour() {
    return (this.end_time !== undefined) ? Math.floor(this.end_time / 60) : undefined;
  }

  setEndHour(hour) {
    this.end_time = (hour === undefined) ? undefined :
      (this.end_time === undefined) ? (hour * 60) : ((hour * 60) + this.end_time % 60);
  }

  getEndMinute() {
    return (this.end_time !== undefined) ? Math.floor(this.end_time % 60) : undefined;
  }

  setEndMinute(minute) {
    this.end_time = (minute === undefined) ? undefined :
      (this.end_time === undefined) ? minute : (60 * Math.floor(this.end_time / 60) + minute);
  }

  getContracts(include_private = false) {
    if (!this.contracts) {
      return undefined;
    }
    
    return include_private ? this.contracts : this.contracts.filter(c => c.is_public);
  }

  setContracts(contracts) {
    this.contracts = undefined;
    if (contracts) {
      this.contracts = [];
      contracts.forEach((c) => {
        this.contracts.push(c.copy());
      });
    }
  }
}

module.exports = Program;
